import { NavLink, Navigate, Route, Routes } from "react-router-dom";

import {
  InvoiceList,
  OpsDashboard,
  OpsTokenGate,
  VenueList,
  WorkerApprovalQueue,
  WorkerList,
  WorkerPayouts,
} from "@/features/ops";
import { cn } from "@/shared/lib/cn";

const TABS = [
  { to: "/ops", label: "Dashboard" },
  { to: "/ops/approvals", label: "Pending approvals" },
  { to: "/ops/workers", label: "All workers" },
  { to: "/ops/payouts", label: "Worker payouts" },
  { to: "/ops/invoices", label: "Invoices" },
  { to: "/ops/venues", label: "Venues" },
];

function NavTab({ to, label }: { to: string; label: string }) {
  return (
    <NavLink
      to={to}
      end
      className={({ isActive }) =>
        cn(
          "relative whitespace-nowrap px-3 py-2.5 text-sm font-medium transition-colors",
          isActive ? "text-primary" : "text-copy-muted hover:text-copy",
        )
      }
    >
      {({ isActive }) => (
        <>
          {label}
          <span
            className={cn(
              "absolute bottom-0 left-2 right-2 h-0.5 rounded-full transition-all",
              isActive ? "bg-primary" : "bg-transparent",
            )}
          />
        </>
      )}
    </NavLink>
  );
}

export function OpsPage() {
  return (
    <OpsTokenGate>
      <div className="min-h-screen bg-background text-copy">
        <header className="sticky top-0 z-40 border-b border-border bg-surface/85 backdrop-blur-md">
          <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-6 py-4">
            <div className="leading-tight">
              <p className="text-base font-semibold tracking-display-tight">OneShift</p>
              <p className="text-[11px] uppercase tracking-wider text-copy-subtle">Ops console</p>
            </div>
          </div>
          <nav className="mx-auto flex max-w-6xl items-center gap-1 overflow-x-auto px-6">
            {TABS.map((tab) => (
              <NavTab key={tab.to} {...tab} />
            ))}
          </nav>
        </header>
        <main className="mx-auto max-w-6xl px-6 py-8">
          <Routes>
            <Route index element={<OpsDashboard />} />
            <Route path="approvals" element={<WorkerApprovalQueue />} />
            <Route path="workers" element={<WorkerList />} />
            <Route path="payouts" element={<WorkerPayouts />} />
            <Route path="invoices" element={<InvoiceList />} />
            <Route path="venues" element={<VenueList />} />
            <Route path="*" element={<Navigate to="/ops" replace />} />
          </Routes>
        </main>
      </div>
    </OpsTokenGate>
  );
}
